import { z } from 'zod';

import { ExternalClientRecord } from 'src/types';
import { zodIssuesIntoErrorsMap } from 'src/utils/validation';

export const identityExternalClientSchema = z.object({
  name: z.string().trim().nonempty(),
  description: z.string().trim().nullish(),
  org_id: z.number().int(),
  legacy_client_id: z.number().int().nullish(),
});

export const createIdentityExternalClientSchema = identityExternalClientSchema;

export const editIdentityExternalClientSchema = identityExternalClientSchema.omit({
  org_id: true,
});

export const getFormValidator = () => (values: Partial<ExternalClientRecord>) => {
  const validationResult = editIdentityExternalClientSchema.safeParse(values);
  return validationResult.success ? {} : zodIssuesIntoErrorsMap(validationResult.error.issues);
};
